import { useTranslation } from "@refinedev/core";
import { InputTypeIcon } from "components/customIcons";
import { InputType } from "interfaces";

export const InputTypeField = ({ value }: { value: InputType }) => {
  const { translate } = useTranslation();

  const INPUT_TYPES = [
    {
      key: InputType.TEXT,
      label: translate("inputType.text"),
      icon: <InputTypeIcon type={InputType.TEXT} />,
    },
    {
      key: InputType.NUMBER,
      label: translate("inputType.number"),
      icon: <InputTypeIcon type={InputType.NUMBER} />,
    },
    {
      key: InputType.DATE,
      label: translate("inputType.date"),
      icon: <InputTypeIcon type={InputType.DATE} />,
    },
    {
      key: InputType.DATETIME,
      label: translate("inputType.dateAndTime"),
      icon: <InputTypeIcon type={InputType.DATETIME} />,
    },
    {
      key: InputType.SELECT,
      label: translate("inputType.singleSelect"),
      icon: <InputTypeIcon type={InputType.SELECT} />,
    },
    {
      key: InputType.MULTI_SELECT,
      label: translate("inputType.multiSelect"),
      icon: <InputTypeIcon type={InputType.MULTI_SELECT} />,
    },
    {
      key: InputType.CHECKBOX,
      label: translate("inputType.checkbox"),
      icon: <InputTypeIcon type={InputType.CHECKBOX} />,
    },
    {
      key: InputType.RADIO_BUTTON,
      label: translate("inputType.radioButton"),
      icon: <InputTypeIcon type={InputType.RADIO_BUTTON} />,
    },
  ];
  
  return (
    <div className="w-fit flex items-center gap-x-2">
      <InputTypeIcon type={value} />{" "}
      {INPUT_TYPES.find((type) => type.key === value)?.label}
    </div>
  );
};
